import { dataMobileApp } from 'dls-icons-data'
import { createIcon } from '../common'

const IconMobileApp = /*#__PURE__*/createIcon(dataMobileApp)
export default IconMobileApp
